package domain.score

import domain.cards.RunState
import engine.controller.ScoreEngine
import engine.controller.defaults.scoring.ScoringResult
import engine.model.GameStats
import engine.model.ScoringRuleBook
import engine.model.SpinType
import engine.model.events.DefaultGameEvents
import engine.model.events.EventOrchestrator
import engine.util.Logger

class CardScoringEngine(
    private val gameId: String,
    private val runState: RunState,
    private val ruleBook: ScoringRuleBook,
) : ScoreEngine {

    override fun calculate(
        spinType: SpinType,
        lines: Int,
        stats: GameStats,
        isBoardEmpty: Boolean,
        pieceName: String,
    ): ScoringResult {
        val result = getPoints(spinType, lines, stats, isBoardEmpty, pieceName)
        val multiplier = runState.totalScoreMultiplier
        return result.copy(pointsAwarded = result.pointsAwarded * multiplier)
    }

    private fun getPoints(
        spinType: SpinType,
        lines: Int,
        stats: GameStats,
        isBoardEmpty: Boolean,
        pieceName: String,
    ): ScoringResult {
        Logger.info { "baseStats: $stats, moveType: $spinType" }
        var basePoints = ruleBook.getBasePoints(spinType, lines)
        val isDifficult = ruleBook.isDifficult(spinType, lines)

        val newB2b = when {
            isDifficult -> stats.b2bCount + 1
            lines >= 1  -> -1
            else        -> stats.b2bCount
        }
        Logger.info { "New b2b: $newB2b" }

        if (isDifficult && stats.b2bCount >= 0) basePoints *= ruleBook.b2bMultiplier

        val newCombo   = if (lines > 0) stats.combo + 1 else -1
        val comboBonus = if (newCombo > 0) ruleBook.comboFactor * newCombo * stats.level else 0.0
        val pcBonus    = if (isBoardEmpty) ruleBook.perfectClearBonus * stats.level else 0.0
        val pointsAwarded = (basePoints * stats.level) + comboBonus + pcBonus

        if (newCombo  != stats.combo)    EventOrchestrator.publish(DefaultGameEvents.ComboTriggered(newCombo, gameId))
        if (newB2b    != stats.b2bCount) EventOrchestrator.publish(DefaultGameEvents.BackToBackTrigger(newB2b, gameId))

        val moveType = ruleBook.getMoveType(spinType, lines, pieceName)
        return ScoringResult(
            pointsAwarded = pointsAwarded,
            newCombo      = newCombo,
            newB2b        = newB2b,
            linesCleared  = lines,
            moveType      = moveType,
        ).also { Logger.info { "result: $it, moveType: ${moveType.displayName}" } }
    }
}
